/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Tlm_0Inputs */

const en_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent_type`)
};

const ar_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الوكيل`)
};

const bn_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent_type`)
};

const de_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agententyp`)
};

const es_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tipo_agente`)
};

const fr_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`type_agent`)
};

const pt_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tipo_agente`)
};

const zh_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理类型`)
};

const tr_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aracı_türü`)
};

const ru_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`тип_агента`)
};

const pl_svc_ai_agent_development_tlm_0 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`typ_agenta`)
};

/**
* | output |
* | --- |
* | "agent_type" |
*
* @param {Svc_Ai_Agent_Development_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tlm_0 = /** @type {((inputs?: Svc_Ai_Agent_Development_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tlm_0(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tlm_0(inputs)
	return en_svc_ai_agent_development_tlm_0(inputs)
});
export { svc_ai_agent_development_tlm_0 as "svc_ai-agent-development_tlm_0" }